import {FemaGoModal} from 'app-ui-componentlibrary';
import _ from 'lodash';
import React, {useState, useEffect} from 'react';
import {connectWithCore} from 'framework/hocs';
import {Segment, Header, Icon, Grid, Button, Loader} from 'semantic-ui-react';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {FundingInformationCommitmentTable} from 'componentLibrary/modules/FundingInformationCommitmentTable';
import {MODES} from 'common/requestDetails/constants';

export function AddCommitmentContainer(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loadingCommitments, setLoadingCommitments] = useState(false);
  const [selectedCommitments, setSelectedCommitments] = useState([]);
  const [regionFilter, setRegionFilter] = useState(null);
  const [commitmentNumFilter, setCommitmentNumFilter] = useState('');
  const [mappedCommitments, setMappedCommitments] = useState([]);
  const [regions, setRegions] = useState([
    {
      key: '',
      value: null,
      text: '',
    },
  ]);

  const {
    addCommitments,
    mappedEntity,
    getCommitments,
    REGIONS,
    foCommitmentData,
    mode,
    grantCommitmentData,
    editable,
    entityIndex,
    displayRegionAlert,
    organization,
    regionAlertContent,
    regionAlertHeader,
    disableMultiCommitmentButton,
  } = props;

  const currentCommitments = _.get(mappedEntity, 'entity.mappedCommitments', []);

  React.useEffect(() => {
    let tempRegions = [{key: '', value: null, text: ''}];
    _.forEach(foCommitmentData, (commitment) => {
      let regionNum = _.get(commitment, 'commitmentRegion', null);
      if (
        (regionNum || regionNum == 0) &&
        !_.find(tempRegions, (region) => region.value == regionNum)
      ) {
        let regionVal = REGIONS[regionNum];
        tempRegions.push({key: regionVal, value: regionNum, text: regionVal});
      }
      if (tempRegions.length > 1) {
        setRegions(tempRegions);
      }
    });
  }, [foCommitmentData]);

  const searchCommitments = async () => {
    setLoadingCommitments(true);
    let commitmentsToSearch = [];
    let isRegionMatch = (region) => {
      return (region || region === 0) && region !== '';
    };
    let isCommitmentFilterMatch = (commitemntNum) => {
      return (
        commitemntNum &&
        _.find(
          foCommitmentData,
          (commitment) => commitment.commitmentNumber == commitemntNum
        ) &&
        !_.find(
          currentCommitments,
          (currCommitment) => commitemntNum == currCommitment.commitmentNumberId
        )
      );
    };
    if (isRegionMatch(regionFilter) && isCommitmentFilterMatch(commitmentNumFilter)) {
      _.each(foCommitmentData, (commitment) => {
        if (
          commitment.commitmentRegion == regionFilter &&
          commitment.commitmentNumber === commitmentNumFilter
        ) {
          commitmentsToSearch.push({
            commitmentNumberId: commitmentNumFilter,
            commitmentRegion: regionFilter,
          });
        }
      });
    } else if (isRegionMatch(regionFilter) && !commitmentNumFilter) {
      if (mode === MODES.CLOSEOUT_RECONCILIATION || mode === MODES.CLOSEOUT_RECON_DEOB) {
        commitmentsToSearch = grantCommitmentData;
      } else {
        commitmentsToSearch = _.filter(foCommitmentData, (commitment) => {
          return commitment.commitmentRegion == regionFilter;
        });
      }
    } else if (isCommitmentFilterMatch(commitmentNumFilter)) {
      _.each(foCommitmentData, (commitment) => {
        if (commitment.commitmentNumber === commitmentNumFilter) {
          commitmentsToSearch.push({
            commitmentNumberId: commitmentNumFilter,
            commitmentRegion: commitment.commitmentRegion,
          });
        }
      });
    }
    try {
      let commitmentData = await getCommitments(commitmentsToSearch);
      let commitmentDataFiltered = _.filter(commitmentData, (filteredCommitment) => {
        return filteredCommitment.commitmentLineNumber === '001';
      });
      const isExist = ({commitmentNumberId, commitmentLineNumber}) =>
        _.find(currentCommitments, {commitmentNumberId, commitmentLineNumber});
      const data = _.filter(commitmentDataFiltered, function (commitment) {
        return !isExist({...commitment});
      });
      setMappedCommitments(data);
      setLoadingCommitments(false);
    } catch (e) {
      console.error(e);
    }
  };

  const entityDisplay = _.get(
    mappedEntity,
    'entity.subGrantId',
    _.get(mappedEntity, 'entity.grantId')
  );
  return (
    <React.Fragment>
      {!disableMultiCommitmentButton && (
        <a
          id="addCommitment"
          href="#"
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <Icon name="plus" /> Add commitment
        </a>
      )}
      {modalOpen ? (
        <FemaGoModal
          open={modalOpen}
          size="large"
          title="Add commitments"
          cancelAction={() => {
            setModalOpen(false);
            setRegionFilter(null);
            setCommitmentNumFilter('');
            setSelectedCommitments([]);
            setMappedCommitments([]);
          }}
          buttonText="Add commitments"
          disableButton={
            selectedCommitments.length === 0 ||
            loadingCommitments ||
            mappedCommitments.length === 0
          }
          confirmAction={() => {
            addCommitments(entityIndex, selectedCommitments);
            setMappedCommitments(
              _.without([...mappedCommitments], ...selectedCommitments)
            );
            setSelectedCommitments([]);
          }}
        >
          <p>Identify the commitments you want to add for {entityDisplay}</p>
          <Segment>
            <Header as="h2">Search</Header>
            <Grid>
              <Grid.Row>
                <Grid.Column verticalAlign="middle">
                  <InlineSelect
                    label="Region"
                    title="Region"
                    id="regionFilter"
                    name="regionFilter"
                    options={regions}
                    handleChange={(e) => {
                      setRegionFilter(e.target.value);
                    }}
                    value={regionFilter}
                  />
                </Grid.Column>
                <Grid.Column verticalAlign="middle" width={4}>
                  <InlineTextBoxField
                    value={commitmentNumFilter}
                    title="Commitment number"
                    label="Commitment number"
                    id="commitmentNumberFilter"
                    name="commitmentNumberFilter"
                    handleChange={(e) => {
                      setCommitmentNumFilter(e.target.value);
                    }}
                  />
                </Grid.Column>
                <Grid.Column verticalAlign="bottom">
                  <Button
                    primary
                    onClick={() => {
                      searchCommitments();
                    }}
                  >
                    Search
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          {loadingCommitments && (
            <Loader inline="centered" active>
              Loading...
            </Loader>
          )}
          {mappedCommitments.length > 0 &&
            (regionFilter || commitmentNumFilter) &&
            !loadingCommitments && (
              <FundingInformationCommitmentTable
                setSelectedCommitments={setSelectedCommitments}
                selectedCommitments={selectedCommitments}
                mappedCommitments={mappedCommitments}
                type="select"
                entityId={entityDisplay}
                editable={editable}
                commitmentSummary={'Commitments available to add'}
                displayRegionAlert={displayRegionAlert}
                organization={organization}
                regionAlertHeader={regionAlertHeader}
                regionAlertContent={regionAlertContent}
              />
            )}
        </FemaGoModal>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
}

export default connectWithCore(AddCommitmentContainer);
